// src/i18n.js
import { createI18n } from "vue-i18n";

import nl from '@/locales/nl.json';
import en from '@/locales/en.json';

const i18n = createI18n({
  legacy: true, // Keep legacy mode for Options API components
  allowComposition: true, // Allow useI18n() in Composition API components
  globalInjection: true, // Keep $t, $i18n in templates
  locale: "nl", // Set the default locale
  fallbackLocale: "nl", // Set the fallback locale
  messages: {
    // Your language messages go here
    nl: {...nl},
    en: {...en},
  },
});

export default i18n;